import { render, staticRenderFns } from "./BulkActionModal.vue?vue&type=template&id=aaa220ec&"
import script from "./BulkActionModal.vue?vue&type=script&lang=js&"
export * from "./BulkActionModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkActionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports